/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationDemographyOfferQuery = gql`
  query GetSimulationDemographyOfferQuery($college: String, $zones: [String]) {
    getSimulationDemographyOffer_simulation_demography(college: $college, zones: $zones) {
      hasOffer 
    }
  }
`;

export default GetSimulationDemographyOfferQuery;
